import {computed, action, observable, configure} from 'mobx'
import {SESSION_EXPIRED_EVENT} from 'util/admin-session'

configure({enforceActions: true})

class Store {
  @observable user = null
  @observable page = null
  @observable form_panel = 'login'
  @observable state = 'pending' // "pending" / "done" / "error"

  constructor() {
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener(SESSION_EXPIRED_EVENT, () => {
        this.setUser(null)
        this.setFormPanel('login')
      })
    }
  }

  @action
  setUser(user) {
    this.user = user
  }

  @action
  finishAuthentication(user) {
    this.user = user
    this.state = 'done'
  }

  @action
  setFormPanel(name) {
    this.form_panel = name
  }

  @action
  setPage(page) {
    this.page = page
  }

  @computed
  get hasBack() {
    let {page} = this
    return page && page.prev
  }
}

export default new Store()
